import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);



export default function SalesChart({ salesData }) {
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: "index",
            intersect: false,
        },
        plugins: {
            legend: {
                position: "top",
                labels: {
                    color: "#5a2d82", // neutral dark gray for text
                    font: {
                        family: "Quicksand, sans-serif",
                        size: 13,
                        weight: 500,
                    },
                    boxWidth: 20,
                    padding: 20,
                },
            },
            title: {
                display: true,
                text: "Sales & Orders Overview",
                color: "#5a2d82",
                font: {
                    family: "Quicksand', sans-serif",
                    size: 19,
                    weight: "800",

                },
                padding: {
                    bottom: 20,
                },
            },
            tooltip: {
                backgroundColor: "#111827",
                titleColor: "#fff",
                bodyColor: "#E5E7EB",
                cornerRadius: 8,
                padding: 12,
            },
        },
        scales: {
            x: {
                ticks: {
                    color: "#6B7280",
                    font: {
                        size: 12,
                    },
                },
                grid: {
                    color: "rgba(0, 0, 0, 0.05)",
                    drawBorder: false,
                },
            },
            y: {
                ticks: {
                    color: "#6B7280",
                    font: {
                        size: 12,
                    },
                },
                grid: {
                    color: "rgba(0, 0, 0, 0.05)",
                    drawBorder: false,
                },
            },
            y1: {
                position: "right",
                ticks: {
                    color: "#6B7280",
                    font: {
                        size: 12,
                    },
                },
                grid: {
                    drawOnChartArea: false,
                },
            },
        },
    };

    const labels = salesData?.map((data) => data?.date);

    const data = {
        labels,
        datasets: [
            {
                label: "Sales",
                data: salesData?.map((data) => data?.sales),
                borderColor: "#d6a8f0", // emerald green
                backgroundColor: "rgba(214, 168, 240, 0.24)",
                fill: true,
                tension: 0.4,
                pointRadius: 4,
                pointHoverRadius: 6,
                yAxisID: "y",
            },
            {
                label: "Orders",
                data: salesData?.map((data) => data?.numOrders),
                borderColor: "#feacc8ff", // blue
                backgroundColor: "rgba(253, 200, 217, 0.34)",
                fill: true,
                tension: 0.4,
                pointRadius: 4,
                pointHoverRadius: 6,
                yAxisID: "y1",
            },
        ],
    };
    return (
        <div
            className="card shadow-sm border-0 p-4 rounded-4"
            style={{ height: "420px", background: "#fff" }}
        >
            <Line options={options} data={data} />
        </div>
    );
}
